
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 360"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M467 0H45C20.1 0 0 20.3 0 45v270c0 24.9 20.3 45 45 45h422c24.7 0 45-20 45-45V45c0-24.7-20.1-45-45-45m-6.3 30c-9.2 9.1-167.4 166.5-172.9 172-8.5 8.5-19.8 13.2-31.8 13.2s-23.3-4.7-31.8-13.2C220.5 198.3 64 42.6 51.3 30h409.4zM30 308.9V51.1l129.6 129L30 308.9zM51.3 330l129.6-128.8 22.1 21.9c14.2 14.2 33 22 53 22s38.9-7.8 53-21.9l22.1-22L460.7 330H51.3zM482 308.9L352.4 180.1 482 51.1v257.8z"}})])
          )
        }
      }
    